export enum WethEventType {
  deposit = "deposit",
  withdrawal = "withdrawal",
}
